@let isAuthenticated = isAuthenticated$ | async;
@let currentUser = currentUser$ | async;
@let access = access$ | async;
@let ordersCount = ordersCount$ | async;
@let standsCount = standsCount$ | async;
@let sipRegistered = sipRegistered$ | async;
@let hasDirectCalls = hasDirectCalls$ | async;
@let incomingCalls = incomingCalls$ | async;
@let visibleCalls = visibleCalls$ | async;
@let hiddenCalls = hiddenCalls$ | async;

<rt-svg-sprite xmlns="http://www.w3.org/1999/html"></rt-svg-sprite>
<ion-app>
  <ion-split-pane contentId="main-content">
    <ion-menu contentId="main-content">

      <!-- ── User header ──────────────────────────────────────────── -->
      <div class="menu-header">
        @if (isAuthenticated) {
          <rt-image-editor
            [width]="52"
            [height]="52"
            [borderRadius]="100"
            [image]="currentUser?.avatar ? config.BASE_URL + '/' + currentUser?.avatar : null"
            (fileChanged)="fileChangeEvent($event)"
          ></rt-image-editor>
        }
        <div class="menu-header__info">
          <span class="menu-header__name">{{ currentUser?.firstName }}</span>
          <span class="menu-header__version">v.{{ appVersion }} · {{ buildLabel }}</span>
          @if (isAuthenticated) {
            <div class="sip-status">
              <span class="sip-dot" [class.sip-dot--on]="sipRegistered"></span>
              <span class="sip-label">SIP</span>
              @if (access?.[PermissionEnum.ACCESS_TO_SIP] && hasDirectCalls) {
                <span class="direct-call-indicator">
                  <ion-icon name="return-down-forward-outline"></ion-icon>
                </span>
              }
            </div>
          }
        </div>
      </div>

      <ion-content>
        @if (isAuthenticated) {
          <ion-list class="nav-list">

            <ion-menu-toggle autoHide="false">
              <ion-item
                [routerLink]="routesMap.dashboard.getAbsolutePath"
                routerLinkActive="menu-item--active"
                [routerLinkActiveOptions]="{ exact: true }"
                routerDirection="root"
                detail="false"
              >
                <div class="item-group">
                  <ion-icon name="home-outline"></ion-icon>
                  <ion-label i18n>Home</ion-label>
                </div>
              </ion-item>
            </ion-menu-toggle>

            @if (access[PermissionEnum.CAN_READ_ORDERS]) {
              <div class="nav-section-label" i18n>Orders</div>

              <ion-menu-toggle autoHide="false">
                <ion-item
                  [routerLink]="routesMap.dashboard['order-list'].accepted.getAbsolutePath"
                  routerLinkActive="menu-item--active"
                  routerDirection="root"
                  detail="false"
                >
                  <div class="item-group">
                    <ion-icon name="receipt-outline"></ion-icon>
                    <ion-label i18n>Order List</ion-label>
                    @if (ordersCount.acceptedCount) {
                      <div class="badge">{{ ordersCount.acceptedCount }}</div>
                    }
                  </div>
                </ion-item>
              </ion-menu-toggle>

              <ion-menu-toggle autoHide="false">
                <ion-item
                  [routerLink]="routesMap.dashboard['order-list'].issued.getAbsolutePath"
                  routerLinkActive="menu-item--active"
                  routerDirection="root"
                  detail="false"
                >
                  <div class="item-group">
                    <ion-icon name="construct-outline"></ion-icon>
                    <ion-label i18n>My Orders</ion-label>
                    @if (ordersCount.issuedCount) {
                      <div class="badge badge__green">{{ ordersCount.issuedCount }}</div>
                    }
                  </div>
                </ion-item>
              </ion-menu-toggle>

              <ion-menu-toggle autoHide="false">
                <ion-item
                  [routerLink]="routesMap.dashboard['order-list']['not-confirmed'].getAbsolutePath"
                  routerLinkActive="menu-item--active"
                  routerDirection="root"
                  detail="false"
                >
                  <div class="item-group">
                    <ion-icon name="alert-circle-outline"></ion-icon>
                    <ion-label i18n>Waiting for Confirmation</ion-label>
                    @if (ordersCount.notConfirmedCount) {
                      <div class="badge badge__yellow">{{ ordersCount.notConfirmedCount }}</div>
                    }
                  </div>
                </ion-item>
              </ion-menu-toggle>
            }

            @if (access[PermissionEnum.CAN_READ_STANDS]) {
              <div class="nav-section-label" i18n>Stands</div>

              <ion-menu-toggle autoHide="false">
                <ion-item
                  [routerLink]="routesMap.dashboard['stand-list'].accepted.getAbsolutePath"
                  routerLinkActive="menu-item--active"
                  routerDirection="root"
                  detail="false"
                >
                  <div class="item-group">
                    <ion-icon name="document-text-outline"></ion-icon>
                    <ion-label i18n>Stand List</ion-label>
                    @if (standsCount.acceptedCount) {
                      <div class="badge">{{ standsCount.acceptedCount }}</div>
                    }
                  </div>
                </ion-item>
              </ion-menu-toggle>

              <ion-menu-toggle autoHide="false">
                <ion-item
                  [routerLink]="routesMap.dashboard['stand-list'].issued.getAbsolutePath"
                  routerLinkActive="menu-item--active"
                  routerDirection="root"
                  detail="false"
                >
                  <div class="item-group">
                    <ion-icon name="build-outline"></ion-icon>
                    <ion-label i18n>My Stands</ion-label>
                    @if (standsCount.issuedCount) {
                      <div class="badge badge__green">{{ standsCount.issuedCount }}</div>
                    }
                  </div>
                </ion-item>
              </ion-menu-toggle>
            }

            @if (access[PermissionEnum.ACCESS_TO_SIP] || access[PermissionEnum.ACCESS_TO_CONTACT_IDENTIFICATION] || currentUser?.isMaster) {
              <div class="nav-section-label">Телефонія</div>

              <ion-menu-toggle autoHide="false">
                <ion-item
                  [routerLink]="routesMap.dashboard.telephony.getAbsolutePath"
                  routerLinkActive="menu-item--active"
                  routerDirection="root"
                  detail="false"
                >
                  <div class="item-group">
                    <ion-icon name="call-outline"></ion-icon>
                    <ion-label>Дзвінки та контакти</ion-label>
                  </div>
                </ion-item>
              </ion-menu-toggle>
            }

            @if (access[PermissionEnum.ACCESS_TO_TELEGRAM_CHAT] || access[PermissionEnum.SUPER_USER]) {
              <ion-menu-toggle autoHide="false">
                <ion-item
                  [routerLink]="routesMap.dashboard.chat.getAbsolutePath"
                  routerLinkActive="menu-item--active"
                  routerDirection="root"
                  detail="false"
                >
                  <div class="item-group">
                    <ion-icon name="chatbubbles-outline"></ion-icon>
                    <ion-label>Чат з клієнтами</ion-label>
                  </div>
                </ion-item>
              </ion-menu-toggle>
            }

            <div class="nav-section-label" i18n>Other</div>

            <ion-menu-toggle autoHide="false">
              <ion-item
                [routerLink]="routesMap.dashboard['code-status'].getAbsolutePath"
                routerLinkActive="menu-item--active"
                routerDirection="root"
                detail="false"
              >
                <div class="item-group">
                  <ion-icon name="warning-outline"></ion-icon>
                  <ion-label i18n>Code statuses</ion-label>
                </div>
              </ion-item>
            </ion-menu-toggle>

            <ion-menu-toggle autoHide="false">
              <ion-item
                [routerLink]="routesMap.dashboard.instructions.getAbsolutePath"
                routerLinkActive="menu-item--active"
                routerDirection="root"
                detail="false"
              >
                <div class="item-group">
                  <ion-icon name="book-outline"></ion-icon>
                  <ion-label i18n>Instructions</ion-label>
                </div>
              </ion-item>
            </ion-menu-toggle>

            <ion-menu-toggle autoHide="false">
              <ion-item
                [routerLink]="routesMap.dashboard.scanner.getAbsolutePath"
                routerLinkActive="menu-item--active"
                routerDirection="root"
                detail="false"
              >
                <div class="item-group">
                  <ion-icon name="qr-code-outline"></ion-icon>
                  <ion-label i18n>QR Scanner</ion-label>
                </div>
              </ion-item>
            </ion-menu-toggle>

            @if (access[PermissionEnum.CAN_READ_COMPLETED_WORK]) {
              <ion-menu-toggle autoHide="false">
                <ion-item
                  [routerLink]="routesMap.dashboard['completed-works'].getAbsolutePath"
                  routerLinkActive="menu-item--active"
                  routerDirection="root"
                  detail="false"
                >
                  <div class="item-group">
                    <ion-icon name="checkmark-done-outline"></ion-icon>
                    <ion-label i18n>Completed works</ion-label>
                  </div>
                </ion-item>
              </ion-menu-toggle>
            }

          </ion-list>
        }

        <!-- ── Account section ────────────────────────────────────── -->
        <ion-list class="nav-list nav-list--bottom">
          <div class="nav-section-label" i18n>Account</div>

          @if (isAuthenticated) {
            <ion-menu-toggle autoHide="false">
              <ion-item
                [routerLink]="routesMap.dashboard.profile.getAbsolutePath"
                routerLinkActive="menu-item--active"
                detail="false"
              >
                <div class="item-group">
                  <ion-icon name="person-circle-outline"></ion-icon>
                  <ion-label i18n>Profile</ion-label>
                </div>
              </ion-item>
            </ion-menu-toggle>

            <ion-menu-toggle autoHide="false">
              <ion-item routerLink="/auth/logout" detail="false">
                <div class="item-group item-group--danger">
                  <ion-icon name="log-out-outline"></ion-icon>
                  <ion-label i18n>Logout</ion-label>
                </div>
              </ion-item>
            </ion-menu-toggle>

          } @else {
            <ion-menu-toggle autoHide="false">
              <ion-item routerLink="/auth/login" routerLinkActive="menu-item--active" routerDirection="root" detail="false">
                <div class="item-group">
                  <ion-icon name="log-in-outline"></ion-icon>
                  <ion-label i18n>Login</ion-label>
                </div>
              </ion-item>
            </ion-menu-toggle>

            <ion-menu-toggle autoHide="false">
              <ion-item routerLink="/auth/registration" routerLinkActive="menu-item--active" routerDirection="root" detail="false">
                <div class="item-group">
                  <ion-icon name="person-add-outline"></ion-icon>
                  <ion-label i18n>Signup</ion-label>
                </div>
              </ion-item>
            </ion-menu-toggle>
          }
        </ion-list>
      </ion-content>
    </ion-menu>

    <div id="main-content">
      <ion-router-outlet></ion-router-outlet>
    </div>
  </ion-split-pane>

  <!-- вхідні дзвінки клієнтів: показуємо завжди, коли лунає сигнал (раніше — лише з прямими дзвінками, і звук був без вікна) -->
  @if (access?.[PermissionEnum.ACCESS_TO_SIP] && incomingCalls?.length) {
    <div class="calls-overlay">
      @if (hiddenCalls?.length) {
        <!-- змахнуті вбік: маленька смужка, торкання — картки знову -->
        @let first = $any(hiddenCalls[0]);
        <button class="calls-pill" (click)="showHiddenCalls()">
          <span class="calls-pill__dot"></span>
          <span class="calls-pill__name">{{ first.client?.name || first.nameCaller || first.phone }}</span>
          @if (hiddenCalls.length > 1) {
            <span class="calls-pill__count">+{{ hiddenCalls.length - 1 }}</span>
          }
          <ion-icon name="chevron-down"></ion-icon>
        </button>
      }
      @for (call of visibleCalls; track call.id) {
        <mobile-call-card [call]="call" (mobileSwipeDismiss)="hideCall(call.id)"></mobile-call-card>
      }
    </div>
  }

  <!-- вбудований телефон: екран вхідного/активного дзвінка поверх будь-якої сторінки -->
  <mobile-softphone-call></mobile-softphone-call>
</ion-app>
